// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"11":"membercard","95":"handle-transfer","443":"about","571":"settings","805":"transactions","809":"transfer"}[chunkId] + "." + {"11":"6aebd028","95":"8ff42da4","443":"ce1f8ed5","571":"414607c5","805":"7a7cd0d1","809":"f39117e3"}[chunkId] + ".css";
};